import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import AcceptInvite from '../pages/acceptInvite';
import AcceptQuote from '../pages/acceptQuote/AcceptQuote';
import AccessDenied from '../pages/accessDenied';
import AssignedPaymentStatus from '../pages/billing/AssignedPaymentStatus';
import MembershipManagement from '../pages/billing/Membership/MembershipManagement';
import MembershipStatusSuccess from '../pages/billing/Membership/MembershipStatusSuccess';
import Payment from '../pages/billing/Payment';
import PaymentStatus from '../pages/billing/PaymentStatus';
import CreatePassword from '../pages/createPassword';
import Dashboard from '../pages/dashboard';
import FileManager from '../pages/fileManager/FileManager';
import ForgotPassword from '../pages/forgotPassword';
import Logout from '../pages/logout';
import MapView from '../pages/mapView';
import UserProfile from '../pages/profile/UserProfile';
import ApproveBookmarkPage from '../pages/project/approve';
import DenyBookmarkPage from '../pages/project/deny';
import ResetPassword from '../pages/resetPassword';
import Signup from '../pages/signup';
import OpenBookmarkPage from '../pages/openBookmark';
import RequestAccessPage from '../pages/requestAccess';
import ViewerRedirect from '../pages/viewerRedirect';
import LoggedOutRoute from '../utilities/loggedOutRoute';
import PrivateRoute from '../utilities/privateRoute';
import routes from './constants';
import MpPayment from '../mp/pages/payment';
import StatusPage from '../pages/statusPage';
var Routes = function() {
    return /*#__PURE__*/ React.createElement("div", {
        className: "App-Container"
    }, /*#__PURE__*/ React.createElement(Switch, null, /*#__PURE__*/ React.createElement(Route, {
        exact: true,
        path: routes.logout,
        component: Logout
    }), /*#__PURE__*/ React.createElement(LoggedOutRoute, {
        exact: true,
        path: [
            routes.login,
            routes.signUp
        ],
        component: Signup
    }), /*#__PURE__*/ React.createElement(LoggedOutRoute, {
        exact: true,
        path: routes.password.create,
        component: CreatePassword
    }), /*#__PURE__*/ React.createElement(LoggedOutRoute, {
        exact: true,
        path: routes.password.reset,
        component: ResetPassword
    }), /*#__PURE__*/ React.createElement(LoggedOutRoute, {
        exact: true,
        path: routes.password.forgot,
        component: ForgotPassword
    }), /*#__PURE__*/ React.createElement(Route, {
        exact: true,
        path: routes.quote.accept(),
        component: AcceptQuote
    }), /*#__PURE__*/ React.createElement(Route, {
        exact: true,
        path: routes.home,
        render: function(param) {
            var location = param.location;
            return /*#__PURE__*/ React.createElement(Redirect, {
                from: routes.home,
                to: {
                    pathname: routes.dashboard,
                    search: location.search
                }
            });
        }
    }), /*#__PURE__*/ React.createElement(PrivateRoute, {
        exact: true,
        path: routes.dashboard,
        component: Dashboard
    }), /*#__PURE__*/ React.createElement(PrivateRoute, {
        exact: true,
        path: [
            routes.view3D.project(),
            routes.view3D.root
        ],
        component: ViewerRedirect
    }), /*#__PURE__*/ React.createElement(PrivateRoute, {
        exact: true,
        allowAnonymous: true,
        path: routes.order.root,
        component: MapView
    }), /*#__PURE__*/ React.createElement(PrivateRoute, {
        exact: true,
        allowAnonymous: true,
        path: routes.order.job(),
        component: MapView
    }), /*#__PURE__*/ React.createElement(PrivateRoute, {
        exact: true,
        path: routes.payment.job(),
        component: Payment
    }), /*#__PURE__*/ React.createElement(PrivateRoute, {
        exact: true,
        path: routes.payment.status(),
        component: PaymentStatus
    }), /*#__PURE__*/ React.createElement(PrivateRoute, {
        exact: true,
        path: [
            routes.fileManager.viewProject(),
            routes.fileManager.root
        ],
        component: FileManager
    }), /*#__PURE__*/ React.createElement(Route, {
        exact: true,
        path: routes.project.acceptInvite,
        component: AcceptInvite
    }), /*#__PURE__*/ React.createElement(PrivateRoute, {
        exact: true,
        path: routes.user.profile,
        component: UserProfile
    }), /*#__PURE__*/ React.createElement(PrivateRoute, {
        exact: true,
        path: routes.user.membershipManagement,
        component: MembershipManagement
    }), /*#__PURE__*/ React.createElement(PrivateRoute, {
        exact: true,
        path: routes.user.membershipChangeSuccess,
        component: MembershipStatusSuccess
    }), /*#__PURE__*/ React.createElement(PrivateRoute, {
        exact: true,
        path: routes.payment.assignedStatus(),
        component: AssignedPaymentStatus
    }), /*#__PURE__*/ React.createElement(PrivateRoute, {
        exact: true,
        path: routes.requestAccess.path,
        component: RequestAccessPage.ShareLink
    }), /*#__PURE__*/ React.createElement(PrivateRoute, {
        exact: true,
        path: routes.requestAccess.project.path,
        component: RequestAccessPage.Project
    }), /*#__PURE__*/ React.createElement(PrivateRoute, {
        exact: true,
        path: routes.requestAccess.job.path,
        component: RequestAccessPage.Job
    }), /*#__PURE__*/ React.createElement(PrivateRoute, {
        exact: true,
        path: routes.openBookmark.path,
        component: OpenBookmarkPage
    }), /*#__PURE__*/ React.createElement(PrivateRoute, {
        exact: true,
        path: routes.projectUser.approve.path,
        component: ApproveBookmarkPage
    }), /*#__PURE__*/ React.createElement(PrivateRoute, {
        exact: true,
        path: routes.projectUser.deny.path,
        component: DenyBookmarkPage
    }), /*#__PURE__*/ React.createElement(PrivateRoute, {
        exact: true,
        path: routes.statusPage.path,
        component: StatusPage
    }), /*#__PURE__*/ React.createElement(Route, {
        exact: true,
        path: routes.accessDenied,
        component: AccessDenied
    }), /*#__PURE__*/ React.createElement(PrivateRoute, {
        exact: true,
        path: routes.mp.payment(),
        component: MpPayment
    })));
};
export default Routes;
